<template>
  <StaticDataTable class="static-table-list stock-pricing-matrix-table">
    <template v-slot:header>
      <tr>
        <th v-if="displayPreferredSupplier"> </th>
        <th>Supplier</th>
        <th v-for="(headerTitle, index) in headerColumnList" :key="index">{{headerTitle}}</th>
        <th v-if="displayPreferredSupplier && userHasUpdatePermission(PermissionTypes.InventoryPermissionTypes.stockManagement)">Actions</th>
      </tr>
    </template>
    <template v-slot:body>
      <tr v-for="(matrixRow, index) in rowList" :key="index">
        <th v-if="displayPreferredSupplier">
          <i class="fas fa-star default-list-item" v-if="matrixRow.isPreferred"></i>
        </th>
        <td class="font-weight-bold">
          <LinkContact :id="matrixRow.id" :name="matrixRow.title" />
        </td>
        <td v-for="(matrixCell, cellIndex) in matrixRow.dataList" :key="cellIndex">
          <span v-show="matrixCell != null">
            {{priceMatrixValue(matrixCell, matrixRow.supplierCurrencyCode)}}
          </span>
        </td>
        <td v-if="displayPreferredSupplier && userHasUpdatePermission(PermissionTypes.InventoryPermissionTypes.stockManagement)">
          <ActionDropMenu :tableAction="true" :forceDropdown="true">
            <DropdownMenuItem @click="setPreferredSupplier(matrixRow.id)" :disabled="matrixRow.isPreferred" icon="fa-star">Set Preferred</DropdownMenuItem>
          </ActionDropMenu>
        </td>
      </tr>
    </template>
  </StaticDataTable>
</template>


<script>
import { mapState } from 'vuex'
import StaticDataTable from "@/components/table/staticDataTable.vue"

export default {
  name: "StockSupplierMatrix",
  components: {
    StaticDataTable
  },
  props: {
    priceCategoryList: Array,   // Columns
    supplierPriceList: Array,   // Rows
    displayCostPrice: {
      type: Boolean,
      default: true
    },
    displayPreferredSupplier: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
    }    
  },
  mounted() {
  },
  computed: {
    ...mapState({
      accountCurrencyCode: state => state.account.currencyCode,
    }),
    headerColumnList() {
      if(!this.priceCategoryList)
        return []

      return this.priceCategoryList
    },
    rowList() {
      if(!this.supplierPriceList || !this.priceCategoryList)
        return []

      return this.supplierPriceList.map(supplierRow => {
        return {
          id: supplierRow.id,
          isPreferred: supplierRow.isPreferred,
          title: supplierRow.title,
          supplierCurrencyCode: supplierRow.supplierCurrencyCode,
          dataList: this.displayCostPrice ? supplierRow.priceData : supplierRow.landedData,
        }
      })
    }
  },
  methods: {
    priceMatrixValue(value, supplierCurrencyCode) {
      if(value == 0)
        return '-'
      if(this.displayCostPrice)
        return this.$options.filters.formatCurrency(value) + ' ' + supplierCurrencyCode
      else
        return this.$options.filters.formatCurrency(value) + ' ' + this.accountCurrencyCode
    },
    setPreferredSupplier(id) {
      this.$emit('requestSetPreferredSupplier', id)
    }
  }
}
</script>
